/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"
import axios from '../../http/axios/index'
import { API } from '@/environment'
// import firebase from 'firebase/app'
// import 'firebase/auth'
import router from '@/router'

export default {
  loginAttempt({ dispatch }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    // if (!payload.checkbox_remember_me) {

    //   // Change firebase Persistence
    //   firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

    //     // If success try to login
    //     .then(function () {
    //       dispatch('login', newPayload)
    //     })

    //     // If error notify
    //     .catch(function (err) {

    //       // Close animation if passed as payload
    //       if (payload.closeAnimation) payload.closeAnimation()

    //       payload.notify({
    //         time: 2500,
    //         title: 'Error',
    //         text: err.message,
    //         iconPack: 'feather',
    //         icon: 'icon-alert-circle',
    //         color: 'danger'
    //       })
    //     })
    // } else {
    //   // Try to login
    //   dispatch('login', newPayload)
    // }
  },
  login({ commit, state, dispatch }, payload) {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }

    // Try to sigin
    // firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

    //   .then((result) => {

    //     // Set FLAG username update required for updating username
    //     let isUsernameUpdateRequired = false

    //     // if username is provided and updateUsername FLAG is true
    //     // set local username update FLAG to true
    //     // try to update username
    //     if (payload.updateUsername && payload.userDetails.displayName) {

    //       isUsernameUpdateRequired = true

    //       dispatch('updateUsername', {
    //         user: result.user,
    //         username: payload.userDetails.displayName,
    //         notify: payload.notify,
    //         isReloadRequired: true
    //       })
    //     }

    //     // Close animation if passed as payload
    //     if (payload.closeAnimation) payload.closeAnimation()

    //     // if username update is not required
    //     // just reload the page to get fresh data
    //     // set new user data in localstorage
    //     if (!isUsernameUpdateRequired) {
    //       router.push(router.currentRoute.query.to || '/')
    //       commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
    //     }
    //   }, (err) => {

    //     // Close animation if passed as payload
    //     if (payload.closeAnimation) payload.closeAnimation()

    //     payload.notify({
    //       time: 2500,
    //       title: 'Error',
    //       text: err.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Google Login
  loginWithGoogle({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    // const provider = new firebase.auth.GoogleAuthProvider()

    // firebase.auth().signInWithPopup(provider)
    //   .then((result) => {
    //     router.push(router.currentRoute.query.to || '/')
    //     commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
    //   }).catch((err) => {
    //     payload.notify({
    //       time: 2500,
    //       title: 'Error',
    //       text: err.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Facebook Login
  loginWithFacebook({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    // const provider = new firebase.auth.FacebookAuthProvider()

    // firebase.auth().signInWithPopup(provider)
    //   .then((result) => {
    //     router.push(router.currentRoute.query.to || '/')
    //     commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
    //   }).catch((err) => {
    //     payload.notify({
    //       time: 2500,
    //       title: 'Error',
    //       text: err.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Twitter Login
  loginWithTwitter({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    // const provider = new firebase.auth.TwitterAuthProvider()

    // firebase.auth().signInWithPopup(provider)
    //   .then((result) => {
    //     router.push(router.currentRoute.query.to || '/')
    //     commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
    //   }).catch((err) => {
    //     payload.notify({
    //       time: 2500,
    //       title: 'Error',
    //       text: err.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Github Login
  loginWithGithub({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
    // const provider = new firebase.auth.GithubAuthProvider()

    // firebase.auth().signInWithPopup(provider)
    //   .then((result) => {
    //     router.push(router.currentRoute.query.to || '/')
    //     commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
    //   }).catch((err) => {
    //     payload.notify({
    //       time: 2500,
    //       title: 'Error',
    //       text: err.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Register User
  registerUser({ dispatch }, payload) {

    // create user using firebase
    // firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
    //   .then(() => {
    //     payload.notify({
    //       title: 'Account Created',
    //       text: 'You are successfully registered!',
    //       iconPack: 'feather',
    //       icon: 'icon-check',
    //       color: 'success'
    //     })

    //     const newPayload = {
    //       userDetails: payload.userDetails,
    //       notify: payload.notify,
    //       updateUsername: true
    //     }
    //     dispatch('login', newPayload)
    //   }, (error) => {
    //     payload.notify({
    //       title: 'Error',
    //       text: error.message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'danger'
    //     })
    //   })
  },

  // Update Username
  updateUsername({ commit }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      let newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, { root: true })

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },

  // JWT
  loginJWT({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response.data.userData) {
            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            // Set accessToken
            localStorage.setItem("accessToken", response.data.accessToken)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, { root: true })

            // Set bearer token in axios
            commit("SET_BEARER", response.data.accessToken)

            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }

        })
        .catch(error => { reject(error) })
    })
  },

  // Register JWT
  registerUserJWT({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({ message: "Password doesn't match. Please try again." })
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem("accessToken", response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, { root: true })

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  // Fetch Access Token
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },

  // Do local login
  async doLogin({ commit }, payload) {
    return await new Promise((resolve, reject) => {
      axios.post(`${API}/oauth/signin`, payload)
        .then(response => {
          if (!response.data.allowedDashboard)
            return reject({ message: "Dont have access to dashboard" })
          // If there's success data in response
          if (response.data.success) {
            localStorage.setItem('role', response.data.role)
            let user_token = response.data.accessToken
            // Navigate User to homepage
            if (response.data.role == 'user') {
              commit('venue/UPDATE_USER_VENUE', response.data.venue, { root: true })
              router.push('/make-booking')
            }
            else {
              if (response.data.permissions == null)
                router.push('/dashboard')
              else {
                // in case of subusers allowed routes
                const firstMatch = response.data.permissions.permissions.find(p => p.selected == true);
                router.push(firstMatch.path)
              }
            }
            // if (response.data.role === 'user')
            //   commit('venue/UPDATE_USER_VENUE', response.data.venue, { root: true })
            // Update user details
            commit('UPDATE_USER_INFO', {
              uid: response.data.user.id,
              displayName: response.data.user.email,
              systemId: response.data.systemId,
              email: response.data.user.email,
              about: response.data.user.description,
              photoURL: response.data.user.picture,
              userRole: response.data.role,
              token: user_token,
              portalRole: response.data.portalRole ? response.data.portalRole : null,
              services: response.data.services,
              permissions: response.data.permissions?response.data.permissions.permissions: {},
              features: response.data.features || [],
              provider: response.data.user.provider
            }, { root: true })
            // Set accessToken
            localStorage.setItem("accessToken", user_token)


            commit('company/UPDATE_DASHBOARD_COMPANY', response.data.company, { root: true })

            // Set bearer token in axios
            commit("SET_BEARER", user_token)
            resolve(response)
          } else {
            reject({ message: "Wrong Email or Password" })
          }

        })
        .catch(error => { reject(error) })
    })
  },

  // do local Registeration
  doRegister({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({ message: "Password doesn't match. Please try again." })
      }
      const data = {
        'firstname': displayName,
        'email': email,
        'password': password,
        'password_confirmation': confirmPassword
      }
      axios.post(`${API}/oauth/register`, data)

        .then(response => {
          // Update data in localStorage
          localStorage.setItem("accessToken", response.data.accessToken)
          commit('UPDATE_USER_INFO', {
            uid: response.data.user.id,
            displayName: response.data.user.firstname,
            email: response.data.user.email,
            about: response.data.user.description,
            photoURL: response.data.user.picture,
            token: response.data.accessToken

          }, { root: true })

          commit("SET_BEARER", response.data.accessToken)

          router.push(router.currentRoute.query.to || '/')
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  // Forgot Password
  forgotPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${API}/oauth/forgot-password`, payload)

        .then(response => {
          // Redirect User
          // router.push(router.currentRoute.query.to || '/')
          resolve(response)
        })
        .catch(error => { reject(error) })
    });
  },

  //Reset Password
  resetPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${API}/oauth/reset-password`, payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })

    })
  },

  //Local Logout
  doLogout({ commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('accessToken') // clear your user's token from localstorage
      localStorage.removeItem('loggedIn');
      localStorage.removeItem('tokenExpiry');
      localStorage.removeItem('userInfo');
      localStorage.setItem('role', 'unknown');

      commit("UPDATE_USER_INFO", {
        uid         : 0,          // From Auth
        displayName : "John Doe", // From Auth
        about       : "",
        status      : "offline",
        userRole    : "unknown",
        portalRole  : null,
        services    : {},
        permissions : {},
        email: '',
        token: ''
      }, { root: true })
      commit('AUTH_LOGOUT')
      commit('company/UPDATE_DASHBOARD_COMPANY', { id: '', name: '' }, { root: true })
      commit('venue/UPDATE_USER_VENUE', {
        id: '',
        name: '',
        display_name: '',
        street: '',
        house_number: '',
        suffix: '',
        postal_code: '',
        city: '',
        country: '',
        timezone: '',
        telephone: '',
        longitude: '',
        latitude: '',
        max_bookings: '',
        extra_info_driver: '',
        company_comment: '',
        internal_comment: ''
      }, { root: true })


      resolve()
    })
  },



}
